var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1004.05 348.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #010101;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #010202;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M335.5,167.64c0-13.62,10.28-23.89,23.89-23.89,6.15,0,12.18,2.16,16.69,6.48v12.5c-2.09-7.66-8.84-12.44-16.69-12.44-9.88,0-17.35,7.46-17.35,17.35s7.46,17.35,17.35,17.35c7.86,0,14.6-4.78,16.69-12.44v12.5c-4.52,4.32-10.54,6.48-16.69,6.48-13.62,0-23.89-10.28-23.89-23.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M381.33,144.73h6.55v45.82l13.09-45.82h13.35v45.82h-6.55v-45.82l-13.09,45.82h-13.35v-45.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M420.21,144.73h36v6.55h-29.46v13.09h17.41c7.4,0,13.35,5.7,13.35,13.16s-6.02,13.03-13.35,13.03h-23.96v-45.82ZM444.23,184.01c3.73,0,6.74-2.75,6.74-6.55s-3.01-6.55-6.74-6.55h-17.48v13.09h17.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M461.78,144.73h6.55v45.82l13.09-45.82h13.35v45.82h-6.55v-45.82l-13.09,45.82h-13.35v-45.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M500.66,144.73h23.96c7.4,0,13.35,5.56,13.35,13.03s-5.96,13.16-13.35,13.16h-17.41v19.64h-6.55v-45.82ZM507.21,151.28v13.09h17.48c3.73,0,6.74-2.75,6.74-6.55s-3.01-6.55-6.74-6.55h-17.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M538.96,167.64c0-13.62,10.28-23.89,23.89-23.89,6.15,0,12.18,2.16,16.69,6.48v12.5c-2.09-7.66-8.84-12.44-16.69-12.44-9.88,0-17.35,7.46-17.35,17.35s7.46,17.35,17.35,17.35c7.86,0,14.6-4.78,16.69-12.44v12.5c-4.52,4.32-10.54,6.48-16.69,6.48-13.62,0-23.89-10.28-23.89-23.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M584.78,190.56v-45.82h6.55v22.85l13.03-22.85h7.53l-13.03,22.85,13.09,22.98h-7.53l-13.09-22.98v22.98h-6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M614.56,144.73h6.55v45.82l13.09-45.82h13.35v45.82h-6.55v-45.82l-13.09,45.82h-13.35v-45.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M653.45,190.56v-45.82h23.5v6.55h-16.95v13.09h16.95v6.55h-16.95v13.09h16.95v6.55h-23.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M697.9,144.73h36v6.55h-29.46v13.09h17.41c7.4,0,13.35,5.7,13.35,13.16s-6.02,13.03-13.35,13.03h-23.96v-45.82ZM721.92,184.01c3.73,0,6.74-2.75,6.74-6.55s-3.01-6.55-6.74-6.55h-17.48v13.09h17.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M739.46,144.73h23.96c7.4,0,13.35,5.56,13.35,13.03s-5.96,13.16-13.35,13.16h-17.41v19.64h-6.55v-45.82ZM746.01,151.28v13.09h17.48c3.73,0,6.74-2.75,6.74-6.55s-3.01-6.55-6.74-6.55h-17.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M781.36,190.56v-45.82h23.5v6.55h-16.95v13.09h16.95v6.55h-16.95v13.09h16.95v6.55h-23.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M811.41,190.56v-45.82h6.55v19.64h28.8v-19.64h6.55v45.82h-6.55v-19.64h-28.8v19.64h-6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M856.57,200.38v-16.37h7.79v-39.28h42.55v39.28h7.86v16.37h-6.55v-9.82h-45.1v9.82h-6.55ZM870.91,151.28v32.73h29.46v-32.73h-29.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M919.35,144.73h6.55v19.64h17.41c7.4,0,13.35,5.7,13.35,13.16s-6.02,13.03-13.35,13.03h-23.96v-45.82ZM925.9,170.92v13.09h17.48c3.73,0,6.74-2.75,6.74-6.55s-3.01-6.55-6.74-6.55h-17.48ZM960.59,144.73h6.55v45.82h-6.55v-45.82Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 176.5,
    cy: 174.09,
    r: 110.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.88,168.46h5.82v-14.54h-6.98v-34.91h-37.82v34.91h-6.92v14.54h5.82v-8.73h40.09v8.73ZM115.72,153.91v-29.09h26.18v29.09h-26.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 238.95,
    y: 119.01,
    width: 5.82,
    height: 40.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 197.76,
    y: 119.01,
    width: 5.82,
    height: 40.73
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "221.26 159.73 209.63 119.01 203.58 119.01 215.21 159.73 221.26 159.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "238.95 119.01 232.9 119.01 221.26 159.73 227.31 159.73 238.95 119.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.44 178.07 109.09 178.07 121.3 220.83 127.66 220.83 115.44 178.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "127.66 220.83 134.01 220.83 146.23 178.07 139.87 178.07 127.66 220.83"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 146.23,
    y: 178.07,
    width: 6.11,
    height: 42.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 102.98,
    y: 178.07,
    width: 6.11,
    height: 42.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.19,208.37v-.06c1.1-2.69,1.71-5.68,1.71-8.86s-.61-6.35-1.83-9.1v-.06c-3.36-7.88-11.06-13.13-20.46-13.13s-17.1,5.25-20.46,13.13v.06c-1.22,2.75-1.83,5.8-1.83,9.1s.61,6.17,1.71,8.86v.06c3.3,8,11.06,13.38,20.59,13.38s17.29-5.38,20.58-13.38ZM164.92,208.37v-.06c-1.59-2.5-2.5-5.56-2.5-8.86s.98-6.54,2.63-9.1l.06-.06c2.87-4.28,7.76-7.02,13.5-7.02s10.63,2.75,13.5,7.02l.06.06c1.65,2.57,2.63,5.68,2.63,9.1s-.92,6.35-2.5,8.86v.06c-2.87,4.46-7.82,7.27-13.68,7.27s-10.81-2.81-13.68-7.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.03,146.99v-.06c1.05-2.56,1.63-5.41,1.63-8.44s-.58-6.05-1.75-8.67v-.06c-3.2-7.51-10.53-12.51-19.49-12.51s-16.29,5-19.49,12.51v.06c-1.16,2.62-1.75,5.53-1.75,8.67s.58,5.88,1.63,8.44v.06c3.14,7.62,10.53,12.74,19.61,12.74s16.47-5.12,19.61-12.74ZM161.39,146.99v-.06c-1.51-2.39-2.39-5.29-2.39-8.44s.93-6.23,2.5-8.67l.06-.06c2.73-4.07,7.39-6.69,12.86-6.69s10.12,2.62,12.86,6.69l.06.06c1.57,2.44,2.5,5.41,2.5,8.67s-.87,6.05-2.39,8.44v.06c-2.73,4.25-7.45,6.92-13.03,6.92s-10.3-2.68-13.03-6.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.35,229.99h6.11v-15.27h-7.33v-36.65h-39.7v36.65h-7.27v15.27h6.11v-9.16h42.09v9.16ZM211.53,214.72v-30.54h27.49v30.54h-27.49Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3514c1d75c7374fcb1e28a90a328af53.svg";
export { ForwardRef as ReactComponent };